// Exports
export default {
	"root": "root_elKW9",
	"zoomButton": "zoomButton_mh6uB",
	"zoomLevel": "zoomLevel_-r9Bp"
};
